import { GET_DASHBOARD_INFO_FAIL, GET_DASHBOARD_INFO_SUCCESS, GET_DASHBOARD_OPTIONS_FAIL, GET_DASHBOARD_OPTIONS_SUCCESS, RESET_DASHBOARD_STATE } from "./actionTypes"
  
  const INIT_STATE = {
    dashboardInfo: [],
    dashboardOptions: []
  }
  
  const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_DASHBOARD_INFO_SUCCESS:
        return {
          ...state,
          dashboardInfo: action.payload
        }
  
      case GET_DASHBOARD_INFO_FAIL:
        return {
          ...state,
          error: action.payload,
        }

      case GET_DASHBOARD_OPTIONS_SUCCESS:
        return {
          ...state,
          dashboardOptions: action.payload
        }
  
      case GET_DASHBOARD_OPTIONS_FAIL:
        return {
          ...state,
          error: action.payload,
        }
      case RESET_DASHBOARD_STATE:
        return {
          ...state,
          dashboardInfo: [],
          dashboardOptions: [],
        }
      default:
        return state
    }
  }
  
  export default Dashboard
  